/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {Suspense, useEffect} from "react";
import {Redirect, Switch, Route, useLocation} from "react-router-dom";
import {shallowEqual, useSelector} from "react-redux";
import {Layout} from "../_metronic/layout";
import BasePage from "./BasePage";
import {Logout, AuthPage} from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import AlertTemplate from "react-alert-template-basic";
import {positions, Provider as AlertProvider, transitions} from "react-alert";

export function Routes() {
	const {isAuthorized} = useSelector(
		({auth}) => ({
			isAuthorized: auth.user != null,
		}),
		shallowEqual
	);

	function useQuery() {
		return new URLSearchParams(useLocation().search);
	}

	let query = useQuery();
	const qPlanId = query.get("plan_id");

	useEffect(() => {
		if (typeof window !== "undefined" && qPlanId && !isAuthorized) window.localStorage.setItem('wantPlan', qPlanId)
	}, [qPlanId])

	const alert_options = {
		// you can also just use 'bottom center'
		position: positions.BOTTOM_CENTER,
		timeout: 5000,
		offset: '30px',
		// you can also just use 'scale'
		transition: transitions.SCALE
	}

	return (
		<AlertProvider template={AlertTemplate}>
			<AlertProvider
				template={AlertTemplate}
				position={positions.TOP_CENTER} //default position for all alerts without individual position
				{...alert_options}
			>
				<Switch>
					{!isAuthorized ? (
						/*Render auth page when user at `/auth` and not authorized.*/
						<Route>
							<AuthPage/>
						</Route>
					) : (
						/*Otherwise redirect to root page (`/`)*/
						<Redirect from="/auth" to="/"/>
					)}

					<Route path="/error" component={ErrorsPage}/>
					<Route path="/logout" component={Logout}/>

					{!isAuthorized ? (
						/*Redirect to `/auth` when user is not authorized*/
						<Redirect to='/auth/login'/>
					) : (
						<Layout>
							<BasePage/>
						</Layout>
					)}
				</Switch>
			</AlertProvider>
		</AlertProvider>
	);
}
